import { render } from "./WarrantiesAndManuals.vue?vue&type=template&id=4225ab88&scoped=true&ts=true"
import script from "./WarrantiesAndManuals.vue?vue&type=script&lang=ts"
export * from "./WarrantiesAndManuals.vue?vue&type=script&lang=ts"

import "./WarrantiesAndManuals.vue?vue&type=style&index=0&id=4225ab88&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.2.47_vue@3.2.47_webpack@5.90.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4225ab88"]])

export default __exports__